module.exports = __webpack_public_path__ + "static/media/break-popup-icon.1e71069d.svg";